module.exports = __webpack_public_path__ + "static/media/woman.dafacbb3.svg";